export default __webpack_public_path__ + "static/LeituraDisplayTwo-Swashes-0c4c8031b0ffba2f19a9330e0990589c.woff";